import { render, staticRenderFns } from "./nofound.vue?vue&type=template&id=5dd48f4b&"
import script from "./nofound.vue?vue&type=script&lang=js&"
export * from "./nofound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports